module.exports = __webpack_public_path__ + "static/media/warning-2.691be301.png";